import { z } from 'zod';
import { DateOnlySchema, IdSchema, ListQuerySchema, PageInfoSchema, TimestampSchema, VersionSchema, } from './common.js';
import { PartyReferenceSchema } from './properties.js';
export const CustomerAccountStatusSchema = z.enum(['prospect', 'active', 'on_hold', 'closed']);
/**
 * Lifecycle and billing state over exactly one canonical company or contact (specification
 * 6.3). The bill-to party is a discriminated union, never two nullable identifiers.
 */
export const CustomerAccountSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    billTo: PartyReferenceSchema,
    billingContactId: IdSchema.nullable(),
    status: CustomerAccountStatusSchema,
    billingTerms: z.string().nullable(),
    creditHold: z.boolean(),
    taxExempt: z.boolean(),
    customerSince: DateOnlySchema.nullable(),
    closedAt: DateOnlySchema.nullable(),
    notes: z.string().nullable(),
    version: VersionSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const CreateCustomerAccountRequestSchema = z.strictObject({
    billTo: PartyReferenceSchema,
    billingContactId: IdSchema.nullable().default(null),
    status: CustomerAccountStatusSchema.default('prospect'),
    billingTerms: z.string().trim().max(100).nullable().default(null),
    creditHold: z.boolean().default(false),
    taxExempt: z.boolean().default(false),
    customerSince: DateOnlySchema.nullable().default(null),
    notes: z.string().trim().max(10_000).nullable().default(null),
});
/** The bill-to party is fixed for the life of the account; close it and open another to rebill. */
export const UpdateCustomerAccountRequestSchema = CreateCustomerAccountRequestSchema.omit({
    billTo: true,
})
    .partial()
    .extend({ version: VersionSchema });
export const CustomerAccountListQuerySchema = ListQuerySchema.extend({
    status: CustomerAccountStatusSchema.optional(),
    companyId: IdSchema.optional(),
    contactId: IdSchema.optional(),
});
export const CustomerAccountListSchema = z.strictObject({
    items: z.array(CustomerAccountSchema),
    page: PageInfoSchema,
});
